import { DomPortalOutlet, TemplatePortal } from '@angular/cdk/portal';
import {
  AfterViewInit,
  ApplicationRef,
  Directive,
  inject,
  Injector,
  OnDestroy,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';

@Directive({
  selector: '[zefPortal]',
  standalone: false,
})
export class Portal implements AfterViewInit, OnDestroy {
  private appRef = inject(ApplicationRef);
  private injector = inject(Injector);
  private templateRef = inject<TemplateRef<any>>(TemplateRef);
  private viewContainerRef = inject(ViewContainerRef);

  private host: DomPortalOutlet;
  private portal: TemplatePortal;

  ngAfterViewInit(): void {
    const target = document.querySelector('.zef-portal');
    if (target) {
      this.host = new DomPortalOutlet(document.querySelector('.zef-portal'), this.appRef, this.injector);

      this.portal = new TemplatePortal(this.templateRef, this.viewContainerRef);

      if (this.host) {
        this.host.attach(this.portal);
      }
    }
  }

  ngOnDestroy(): void {
    if (this.host) {
      this.host.detach();
    }
  }
}
